// src/layouts/dashboard/nav/borrowerconfig.js

import SvgColor from '../../../components/svg-color';

// Helper for icons (keeps consistency with your other configs)
const icon = (name) => (
  <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
);

const borrowerConfig = [
//   {
//     title: 'Dashboard',
//     path: '/dashboard/app',
//     icon: icon('ic_analytics'),
//   },
  {
    title: 'My Loans',
    path: '/dashboard/borrower/loan',
    icon: icon('ic_file'),
  },
//   {
//     title: 'Upload Documents',
//     path: '/borrower/documents',
//     icon: icon('ic_cloud_upload'),
//   },
//   {
//     title: 'Payments',
//     path: '/borrower/payments',
//     icon: icon('ic_wallet'),
//   },
//   {
//     title: 'Messages',
//     path: '/borrower/messages',
//     icon: icon('ic_chat'),
//   },
//   {
//     title: 'Profile',
//     path: '/borrower/profile',
//     icon: icon('ic_user'),
//   },
];

export default borrowerConfig;
